import { render } from "./Coupon.vue?vue&type=template&id=b5ae1cd8&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=b5ae1cd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5ae1cd8"

export default script